import React, { useState } from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { useExercise } from '../ExerciseProvider'
import { TextArea } from './index'
import { cn } from '~/lib/utils'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~/lib/ui/select'

const PartTwo = () => {
  const { t } = useTranslation('discovering_your_consulting_niche')
  const questions = t('pages.1.questions', { returnObjects: true })
  return (
    <div>
      <div className="subtitle">{t('pages.1.instructions')}</div>
      <div className="mt-4 flex flex-col gap-4">
        {questions.map((questionInfo, questionIdx) => (
          <Question
            key={`question-${questionIdx}`}
            questionInfo={questionInfo}
            questionIdx={questionIdx}
          />
        ))}
      </div>
    </div>
  )
}

export default PartTwo

const Question = ({ questionInfo, questionIdx }) => {
  const { t } = useTranslation('discovering_your_consulting_niche')
  const { handleChange, getResponse } = useExercise()
  const { question, options, description, type } = questionInfo
  const [feedback, setFeedback] = useState('')
  const [feedbackClass, setFeedbackClass] = useState(
    'opacity-0 bg-white max-h-0',
  )

  const fadeIn = () => {
    setFeedbackClass(
      'opacity-100 bg-gray-100 h-auto my-2 rounded-md border border-gray-500 p-4 ',
    )
  }
  const fadeOut = () => {
    setFeedbackClass('opacity-0 bg-white max-h-0')
  }

  const feedbackExists = options
    ? options.some((option) => option.feedback)
    : false

  const handleValueChange = (text) => {
    handleChange(1, questionIdx, null, text)
    fadeOut()
    const option = options.find((option) => option.text === text)
    setTimeout(() => {
      setFeedback(option.feedback)
      fadeIn()
    }, 500)
  }

  const handleTextFocus = () => {
    fadeOut()
    setTimeout(() => {
      fadeIn()
    }, 500)
  }

  const showFeedback = feedbackExists || !!description

  return (
    <div>
      <div>{question}</div>
      <div className="flex flex-col gap-2">
        {options && (
          <Select
            onValueChange={handleValueChange}
            value={getResponse(1, questionIdx)}
          >
            <SelectTrigger>
              <SelectValue placeholder={t('select_placeholder')} />
            </SelectTrigger>
            <SelectContent>
              {options.map((option, idx) => (
                <SelectItem key={`option-${idx}`} value={option.text}>
                  {option.text}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
      </div>
      {type === 'text' && (
        <TextArea onFocus={handleTextFocus} slug={'top-three-vals'} />
      )}
      {showFeedback && (
        <div
          className={cn(`transition-all duration-1000 fade-in`, feedbackClass)}
        >
          {description || feedback}
        </div>
      )}
    </div>
  )
}
